<template>
<div>
  <el-dialog
    :title="title"
    :close-on-click-modal="false"
     v-dialogDrag
     @close="closeDialog"
    :visible.sync="visible">
    <el-button v-if="method != 'add'" size="medium" class="mb8" icon="el-icon-edit" type="warning"  @click="handEditorView(method)" :disabled="!hasPermission('unmspace:cecUnmSpace:edit')">编辑</el-button>
    <el-form :model="inputForm" size="small" ref="inputForm" v-loading="loading" :class="method==='view'?'readonly':''"  :disabled="method==='view'"
             label-width="120px">
      <el-row  :gutter="15">
        <el-col :span="24">
            <el-form-item label="排序" prop="sort"
                :rules="[
                  {required: true, message:'排序不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.sort" placeholder="请填写排序"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="24">
            <el-form-item label="中文名称" prop="nameCn"
                :rules="[
                  {required: true, message:'中文名称不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.nameCn" placeholder="请填写中文名称"  maxlength="64"    ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="24">
            <el-form-item label="英文名称" prop="nameEn"
                :rules="[
                  {required: true, message:'英文名称不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.nameEn" placeholder="请填写英文名称"  maxlength="64"    ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="类型" prop="type"
                :rules="[
                  {required: true, message:'类型不能为空', trigger:'blur'}
                 ]">
                <el-select v-model="inputForm.type" placeholder="请选择"  style="width: 100%;">
                          <el-option
                            v-for="item in  $dictUtils.getDictList('cec_room')"
                            :key="item.id"
                            :label="item.label"
                            :value="item.id">
                          </el-option>
                      </el-select>
           </el-form-item>
        </el-col>
        <el-col :span="24">
            <el-form-item label="包含功能空间" prop="functionalSpaceIds.id"
                :rules="[
                  {required: true, message:'功能空间不能为空', trigger:'blur'}
                 ]">
          <GridSelect
            title="选择功能空间"
            labelName = 'nameEn'
            :disabled="method==='view'"
            labelValue = 'id'
            :value = "inputForm.functionalSpaceIds.id"
            :limit="10"
            @getValue='(value) => {inputForm.functionalSpaceIds.id=value}'
            :columns="[
            {
              prop: 'nameCn',
              label: '中文名称'
            },
            {
              prop: 'nameEn',
              label: '英文名称'
            }
            ]"
            :searchs="[
            {
              prop: 'nameCn',
              label: '中文名称'
            },
            {
              prop: 'nameEn',
              label: '英文名称'
            }
            ]"
            dataListUrl="/unmspace/cecUnmFunctionalSpace/list"
            queryEntityUrl="/unmspace/cecUnmFunctionalSpace/queryById">
          </GridSelect>
           </el-form-item>
        </el-col>
        <el-col :span="24">
            <el-form-item label="包含项目" prop="projectIds.id"
                :rules="[
                  {required: true, message:'包含项目不能为空', trigger:'blur'}
                 ]">
          <GridSelect
            title="选择包含项目"
            labelName = 'nameCn'
            labelValue = 'id'
            :value = "inputForm.projectIds.id"
            :limit="10"
            showType="table"
            @getValue='(value) => {inputForm.projectIds.id=value}'
            :columns="[
            {
              prop: 'code',
              label: '编码'
            },
            {
              prop: 'nameCn',
              label: '中文名称'
            }
            ]"
            :searchs="[
            {
              prop: 'code',
              label: '编码'
            },
            {
              prop: 'nameCn',
              label: '中文名称'
            }
            ]"
            dataListUrl="/unmspace/cecUnmProject/list"
            queryEntityUrl="/unmspace/cecUnmProject/queryById">
          </GridSelect>
           </el-form-item>
        </el-col>
        <el-col :span="24" v-if="method==='edit' || method==='view'">
            <el-form-item label="图片" prop=""
                :rules="[
                 ]">
	            <ImageUploadCustom v-model="inputForm.pic" :multiple="false" :disabled="method==='view'" :otherPrams="otherPrams" action="/unmfile/cecUnmFileupload"  tip="单个图片不要超过10M"></ImageUploadCustom>
           </el-form-item>
        </el-col>
        </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeDialog">关闭</el-button>
      <el-button size="small" type="primary" v-if="method != 'view'" @click="doSubmit()" v-noMoreClick>确定</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
  import GridSelect from '@/components/gridSelect/setTagTable.vue'
  import cecUnmSpaceService from '@/api/unmspace/cecUnmSpaceService'
  import ImageUploadCustom from '@/components/upload/ImageUploadCustom'
  export default {
    data () {
      return {
        title: '',
        method: '',
        visible: false,
        loading: false,
        inputForm: {
          id: '',
          nameEn: '',
          nameCn: '',
          functionalSpaceIds: {
            id: ''
          },
          projectIds: {
            id: ''
          },
          sort: '',
          pic: [],
          type: ''
        },
        otherPrams: {
          id: '',
          type: 'space'
        }
      }
    },
    components: {
      GridSelect,
      ImageUploadCustom
    },
    methods: {
      // 关闭弹窗
      closeDialog () {
        this.inputForm.pic = []
        this.visible = false
      },
      // 切换编辑状态
      handEditorView (method) {
        this.method = method === 'view' ? 'edit' : 'view'
      },
      init (method, id) {
        this.method = method
        this.inputForm.id = id
        if (method === 'add') {
          this.title = `新建空间表`
        } else if (method === 'edit') {
          this.title = '修改空间表'
        } else if (method === 'view') {
          this.title = '查看空间表'
        }
        this.visible = true
        this.loading = false
        this.$nextTick(() => {
          this.$refs.inputForm.resetFields()
          if (method === 'edit' || method === 'view') { // 修改或者查看
            this.loading = true
            cecUnmSpaceService.queryById(this.inputForm.id).then(({data}) => {
              this.inputForm = this.recover(this.inputForm, data)
              this.otherPrams.id = data.id
              this.inputForm.pic = data.cecUnmFileDTOList
              this.loading = false
            })
          }
        })
      },
      // 表单提交
      doSubmit () {
        this.$refs['inputForm'].validate((valid) => {
          if (valid) {
            this.loading = true
            cecUnmSpaceService.save(this.inputForm).then(({data}) => {
              this.visible = false
              this.$message.success(data)
              this.$emit('refreshDataList')
              this.loading = false
            }).catch(() => {
              this.loading = false
            })
          }
        })
      }
    }
  }
</script>
<style scoped>
::v-deep .el-dialog__body{
 padding: 10px 20px !important;
}
</style>
